export const languagesList = [
	{ name: "English", flag: "🇬🇧" },
	{ name: "Spanish", flag: "🇪🇸" },
	{ name: "Catalan", flag: "🇪🇸" },
	{ name: "Arabic", flag: "🇸🇦" },
	{ name: "Assamese", flag: "🇮🇳" },
	{ name: "Bengali", flag: "🇧🇩" },
	{ name: "Burmese", flag: "🇲🇲" },
	{ name: "Cebuano", flag: "🇵🇭" },
	{ name: "Chichewa", flag: "🇲🇼" },
	{ name: "Dutch", flag: "🇳🇱" },
	{ name: "French", flag: "🇫🇷" },
	{ name: "German", flag: "🇩🇪" },
	{ name: "Greek", flag: "🇬🇷" },
	{ name: "Gujarati", flag: "🇮🇳" },
	{ name: "Hausa", flag: "🇳🇬" },
	{ name: "Hindi", flag: "🇮🇳" },
	{ name: "Hmong", flag: "🇺🇸" },
	{ name: "Igbo", flag: "🇳🇬" },
	{ name: "Italian", flag: "🇮🇹" },
	{ name: "Japanese", flag: "🇯🇵" },
	{ name: "Javanese", flag: "🇮🇩" },
	{ name: "Kannada", flag: "🇮🇳" },
	{ name: "Kazakh", flag: "🇰🇿" },
	{ name: "Khmer", flag: "🇰🇭" },
	{ name: "Korean", flag: "🇰🇷" },
	{ name: "Magahi", flag: "🇮🇳" },
	{ name: "Malay", flag: "🇲🇾" },
	{ name: "Malayalam", flag: "🇮🇳" },
	{ name: "Mandarin Chinese", flag: "🇨🇳" },
	{ name: "Marathi", flag: "🇮🇳" },
	{ name: "Marwari", flag: "🇮🇳" },
	{ name: "Madurese", flag: "🇮🇩" },
	{ name: "Maithili", flag: "🇮🇳" },
	{ name: "Nepali", flag: "🇳🇵" },
	{ name: "Norwegian", flag: "🇳🇴" },
	{ name: "Pashto", flag: "🇦🇫" },
	{ name: "Persian", flag: "🇮🇷" },
	{ name: "Polish", flag: "🇵🇱" },
	{ name: "Portuguese", flag: "🇵🇹" },
	{ name: "Punjabi", flag: "🇮🇳" },
	{ name: "Russian", flag: "🇷🇺" },
	{ name: "Sinhalese", flag: "🇱🇰" },
	{ name: "Sinhala", flag: "🇱🇰" },
	{ name: "Somali", flag: "🇸🇴" },
	{ name: "Swahili", flag: "🇰🇪" },
	{ name: "Swedish", flag: "🇸🇪" },
	{ name: "Tamil", flag: "🇮🇳" },
	{ name: "Telugu", flag: "🇮🇳" },
	{ name: "Thai", flag: "🇹🇭" },
	{ name: "Turkish", flag: "🇹🇷" },
	{ name: "Turkmen", flag: "🇹🇲" },
	{ name: "Ukrainian", flag: "🇺🇦" },
	{ name: "Urdu", flag: "🇵🇰" },
	{ name: "Vietnamese", flag: "🇻🇳" },
	{ name: "Yoruba", flag: "🇳🇬" },
];
